/** What a request is called when nobody named it. */
export const DEFAULT_PORTAL_REQUEST_NAME = "Document request"

/**
 * The one name a request goes by, everywhere it is shown or sent: its own
 * title. A request is named by what it asks for, never by a month, so there
 * is no period fallback here.
 */
export const portalRequestName = (request: {
  title: string | null | undefined
}): string => request.title?.trim() || DEFAULT_PORTAL_REQUEST_NAME

/**
 * The title a new request is stored with: the one the firm typed, else the
 * name of the list it came from, else the default name.
 */
export const portalRequestTitleFor = (input: {
  title?: string | null
  templateName?: string | null
}): string =>
  input.title?.trim() ||
  input.templateName?.trim() ||
  DEFAULT_PORTAL_REQUEST_NAME
